import _ from 'lodash';
import { Filters } from '../store/interfaces';

const UPPERCASE_PARAMS = new Set(['sort_by', 'sort_order']);
const KEY_MAP: Record<string, string> = { sort_direction: 'sort_order' };

export const buildClientsFilterQuery = (filters?: Filters): string => {
  if (!filters) {
    return '';
  }

  let filterParam = '';
  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      filterParam += filterParam ? '&' : '';
      const snakeKey = _.snakeCase(key);
      const paramKey = KEY_MAP[snakeKey] || snakeKey;
      const paramValue = UPPERCASE_PARAMS.has(paramKey)
        ? filters[key].toUpperCase()
        : filters[key];
      filterParam += `${paramKey}=${encodeURIComponent(paramValue)}`;
    }
  });

  return filterParam;
};
